export default "__VITE_ASSET__9bc26bcb__"